import { contactInfo } from '@/mocks/homeData';

export default function ConvitePage() {
  return (
    <div className="min-h-screen bg-background-50">
      {/* Hero com vídeo */}
      <section className="relative w-full pt-28 pb-16 md:pt-36 md:pb-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-background-100 to-background-50"></div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-accent-600 font-semibold mb-4">
              <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
              Convite da Dra. Marihana
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4 max-w-3xl mx-auto">
              Conheça de perto a{' '}
              <span className="italic font-normal">excelência</span> que transforma sorrisos
            </h1>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
              Assista ao vídeo exclusivo onde a Dra. Marihana Pasquali apresenta a clínica, explica os principais tratamentos e faz um convite especial para você dar o primeiro passo rumo ao sorriso que sempre desejou.
            </p>
          </div>

          {/* Player de vídeo */}
          <div className="max-w-4xl mx-auto mb-16">
            <div className="relative rounded-2xl overflow-hidden shadow-lg bg-foreground-950 aspect-video">
              <video
                className="w-full h-full"
                controls
                playsInline
                preload="auto"
                muted
              >
                <source
                  src="https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/4d4417f8-4322-4248-83f5-a4e4a667b9fc_07211.mp4"
                  type="video/mp4"
                />
                Seu navegador não suporta a reprodução de vídeos.
              </video>
            </div>
            <p className="text-center text-foreground-500 text-sm mt-4 font-medium">
              Assista ao vídeo completo e agende sua avaliação
            </p>
          </div>

          {/* Highlights */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-16">
            {[
              {
                icon: 'ri-building-2-line',
                title: 'Nossa Clínica',
                text: 'Conheça a estrutura completa na Faria Lima — 6º andar com vista panorâmica, salas equipadas com tecnologia 3D e ambiente pensado para seu conforto.',
              },
              {
                icon: 'ri-stethoscope-line',
                title: 'Nossos Serviços',
                text: 'Da avaliação ao tratamento: implantes, Invisalign, cirurgia bucomaxilofacial, estética dental e muito mais. Tudo em um só lugar.',
              },
              {
                icon: 'ri-heart-pulse-line',
                title: 'Nosso Cuidado',
                text: 'Atendimento humanizado com escuta ativa. Cada sorriso é único — e o plano de tratamento também. Sua confiança é nossa prioridade.',
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-background-50 border border-background-200/60 rounded-2xl p-6 md:p-7 hover:border-accent-200 transition-all duration-300"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-50 mb-5">
                  <i className={`${item.icon} text-accent-600 text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-accent-50 flex items-center justify-center">
            <i className="ri-calendar-check-line text-accent-600 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Pronto para transformar seu sorriso?
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed mb-8 max-w-xl mx-auto">
            Agende agora mesmo sua avaliação personalizada com a Dra. Marihana Pasquali. Atendimento premium na Faria Lima, São Paulo.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={`https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação%20com%20a%20Dra.%20Marihana.`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ea952] text-white text-sm font-semibold px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Agendar pelo WhatsApp
            </a>
            <a
              href={`tel:${contactInfo.phone}`}
              className="whitespace-nowrap inline-flex items-center gap-2 border border-foreground-200 hover:border-accent-400 text-foreground-700 hover:text-accent-600 text-sm font-medium px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              {contactInfo.phone}
            </a>
          </div>
        </div>
      </section>

      {/* Endereço e informações */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="bg-background-50 border border-background-200/60 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start gap-8">
            <div className="w-full md:w-1/2">
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">Venha nos visitar</h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-accent-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-foreground-950 text-sm font-medium">Av. Brigadeiro Faria Lima, 2355</p>
                    <p className="text-foreground-500 text-xs">6º andar — Jardim Paulistano, São Paulo — SP</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 flex-shrink-0 mt-0.5">
                    <i className="ri-subway-line text-accent-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-foreground-950 text-sm font-medium">Estação Faria Lima</p>
                    <p className="text-foreground-500 text-xs">Apenas 5 minutos a pé — Linha 4 Amarela</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50 flex-shrink-0 mt-0.5">
                    <i className="ri-car-line text-accent-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-foreground-950 text-sm font-medium">Estacionamento no local</p>
                    <p className="text-foreground-500 text-xs">Valet service disponível para seu conforto</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/2">
              <div className="rounded-xl overflow-hidden aspect-video bg-background-100">
                <iframe
                  src={contactInfo.googleMapsEmbed}
                  title="Localização do consultório da Dra. Marihana Pasquali"
                  className="w-full h-full border-0"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}